// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.solvayMain = {
    attach: function (context) {
      once('.dropdown','.dropdown-toggle', context)
        .forEach(function (button) {

          button.addEventListener('click', function (context) {
            context.preventDefault();

            // Toggle show class on button
            button.classList.toggle('show');

            // Find the corresponding dropdown menu
            const dropdown = button.parentElement.querySelector(
              '.dropdown-menu'
            );

            if (dropdown) {
              dropdown.classList.toggle('show');
            }

            // Update aria-expanded
            button.setAttribute(
              'aria-expanded',
              button.classList.contains('show')
            );
          });

        });
      // Open external links in a new window.
      once('external-links', 'a[href^="http"], a[href^="//"]', context).forEach( (link) => {

        if (!link.href.includes(window.location.host)) {
          link.setAttribute("target", "_blank");
        }
      });

      once('onetrust-delay', 'body', context).forEach(() => {
        window.addEventListener('load', function () {
          setTimeout(function () {
            const banner = document.getElementById('onetrust-banner-sdk');
            if (banner) {
              banner.style.display = 'block';
            }
          }, 500);
        });
      });
    }
  };

})(Drupal, once);